import { NgModule } from '@angular/core';
import { CommonDataService } from '../Services/commonDataService';
import { HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

@NgModule({
    imports: [
      HttpClientModule
    ],
    declarations: [],
    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        CommonDataService
    ],
    exports: []
})
export class CoreModule {
}
